import { categoryOptions } from './CategoryTag.model';

export const filterCategories = (categoryAgency?: string) => {
  if (!categoryAgency) {
    return [];
  }

  const categoryList = categoryAgency
    .split(',')
    .map((category) => category.trim());
  const filteredVerticals = Object.values(categoryOptions).filter((vertical) =>
    categoryList.includes(vertical.name),
  );

  return filteredVerticals;
};
